import React, { useState } from "react";
import { useQuery } from "react-query";
import axiosInstance from "../../config/axios";
import { API_URLS } from "../../config/APIUrls";
import { Close, PersonPin } from "@mui/icons-material";
import CustomTable from "../../Shared/CustomTable";
import moment from "moment";
import { useFormik } from "formik";
import { Button, Dialog, DialogContent, DialogTitle, IconButton, MenuItem, TextField } from "@mui/material";
import FollowupList from "../followup/FollowupList";


const TodayFolowup = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [openFollowup, setOpenFollowup] = useState(false);
    const [selectedLeadId, setSelectedLeadId] = useState(null);
    const userRole = localStorage.getItem("type")

    const { data: todayData, isLoading } = useQuery(
        ["today_followups"],
        () => axiosInstance.get(API_URLS.today_lead_folowup)
    );

    const followups = todayData?.data?.data || [];


    const tableHead = [
        "S.No.",
        " Followup Date ",
        "FollowUp",
        "Status",
        "Remark",
        "Lead Name",
        "Mobile",
        ...(userRole === "admin" ? ["Employee"] : []),
    ];

    const tableRow = followups.map((f, idx) => [
        <span className="flex gap-2">
            {idx + 1}
        </span>,
        f.crm_next_followup_date
            ? moment(f.crm_next_followup_date).format("YYYY-MM-DD")
            : "--",

        <Button
            className="!bg-green-600 !text-white"
            onClick={() => {
                setSelectedLeadId(f.id);
                setOpenFollowup(true);
            }}
        >
            View
        </Button>,

        f.followup_status_name || "--",   // ✅ correct
        f.crm_remark || "--",             // ✅ correct
        f.crm_lead_name || "--",
        f.crm_mobile || "--",
        ...(userRole === "admin" ? [f.assigned_employee_name || "--"] : []),
    ]);

    if (isLoading) return <p>Loading...</p>;
    return (
        <div className=" px-4">
            <>
                <h2 className="mt-10 font-bold mb-4">
                    Today Follow-ups
                </h2>

                <div className="h-[350px] overflow-y-auto">
                    <CustomTable
                        tablehead={tableHead}
                        tablerow={tableRow}
                        isLoading={isLoading}
                    />
                </div>
                {/* <CustomTable
                    tablehead={tableHead}
                    tablerow={tableRow}
                    isLoading={isLoading}
                /> */}
                <Dialog
                    open={openFollowup}
                    onClose={() => setOpenFollowup(false)}
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle className="flex justify-between items-center">
                        Follow-up
                        <IconButton onClick={() => setOpenFollowup(false)}>
                            <Close />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent
                        dividers
                        sx={{
                            height: "70vh",
                            display: "flex",
                            flexDirection: "column",
                            padding: 0,
                        }}
                    >
                        {selectedLeadId && (
                            <FollowupList leadId={selectedLeadId} />
                        )}
                    </DialogContent>
                </Dialog>
            </>
        </div>
    );

};

export default TodayFolowup;
